<div class="orders-invoice mt-3">
  <p-table
    #dtTrackingList
    stripedRows
    [rowHover]="true"
    [rows]="25"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    [size]="'small'"
    [resizableColumns]="true"
    [value]="workflowTrackingList"
    styleClass="p-datatable-customers invoiceListing"
    [rowHover]="true"
    [rows]="4"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    selectionMode="single"
    dataKey="trackingNumber"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <!-- <th *ngIf="showEdit"></th> -->
        <th class="name text-left">Vendor-SKU</th>
        <th class="number text-left">Quantity</th>
        <th class="name text-left">Tracking Number</th>
        <th class="name text-left">Shipping Method</th>
        <th class="status text-left">Delivery Status</th>
        <th class="name text-left">Action</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-workflowTracking
      let-rowIndex="rowIndex"
      let-editing="editing">
      <ng-container>
        <tr class="p-selectable-row" [pSelectableRow]="workflowTracking">
          <td class="name text-left">
            {{ workflowTracking.vendorSKU }}
          </td>

          <td class="number text-left">
            {{ workflowTracking.quantity }}
          </td>
          <td class="name text-left">
            <a
              class="link"
              *ngIf="showDetailLinks && workflowTracking.isMasterTracking"
              (click)="trackingHistory(workflowTracking)"
              ><strong>{{ workflowTracking.trackingNumber }}</strong></a
            >
            <div *ngIf="!showDetailLinks && workflowTracking.isMasterTracking">
              <strong>{{ workflowTracking.trackingNumber }}</strong>
            </div>
            <a
              class="link pd-lf"
              *ngIf="
                showDetailLinks &&
                !workflowTracking.isMasterTracking &&
                workflowTracking.masterTrackingNumber &&
                workflowTracking.masterTrackingNumber !== ''
              "
              (click)="trackingHistory(workflowTracking)"
              >{{ workflowTracking.trackingNumber }}</a
            >
            <div
              class="pd-lf"
              *ngIf="
                !showDetailLinks &&
                !workflowTracking.isMasterTracking &&
                workflowTracking.masterTrackingNumber &&
                workflowTracking.masterTrackingNumber !== ''
              ">
              {{ workflowTracking.trackingNumber }}
            </div>
            <a
              class="link"
              *ngIf="
                showDetailLinks &&
                !workflowTracking.isMasterTracking &&
                (!workflowTracking.masterTrackingNumber ||
                  workflowTracking.masterTrackingNumber === '')
              "
              (click)="trackingHistory(workflowTracking)"
              >{{ workflowTracking.trackingNumber }}</a
            >
            <div
              *ngIf="
                !showDetailLinks &&
                !workflowTracking.isMasterTracking &&
                (!workflowTracking.masterTrackingNumber ||
                  workflowTracking.masterTrackingNumber === '')
              ">
              {{ workflowTracking.trackingNumber }}
            </div>
          </td>
          <td class="name text-left">
            {{
              getShippingMethodDisplay(
                workflowTracking.shippingMethodName,
                workflowTracking.carrierShippingMethod
              )
            }}
          </td>

          <td class="status text-left">
            <ng-container *ngIf="workflowTracking.isManualTracking">
              <p-select
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="workflowTracking.deliveryStatusId"
                notFoundText="No Status Found"
                [filter]="true"
                [showClear]="true"
                [options]="statusList"
                optionLabel="name"
                optionValue="id"
                appendTo="body"
                styleClass="tracking-status-select"
                panelStyleClass="tracking-status-panel"
                [disabled]="isDisableLink"
                (onChange)="onStatusChange(workflowTracking)">
              </p-select>
            </ng-container>
            <span *ngIf="!workflowTracking.isManualTracking">
              {{ workflowTracking.deliveryStatus }}
            </span>
          </td>

          <td
            class="name tracking-detail-cell"
            [ngClass]="
              showDetailLinks ? 'text-left' : 'text-left  align-middle'
            ">
            <a
              class="link"
              *ngIf="!workflowTracking.isFromDatabase && !showDetailLinks"
              (click)="deleteRowPageList(workflowTracking)">
              <i class="pi pi-times"></i>
            </a>
            <a
              *ngIf="workflowTracking.isFromDatabase && !showDetailLinks"
              class="link"
              (click)="deleteTrackingRecord(workflowTracking)">
              <i class="pi pi-trash"></i>
            </a>
            <a
              *ngIf="showDetailLinks"
              class="link tracking-detail-link"
              (click)="trackingDetails(workflowTracking)">
              Detail
            </a>
            <p-button
              *ngIf="showDetailLinks"
              [disabled]="isDisableLink"
              icon="pi pi-trash"
              variant="text"
              styleClass="tracking-delete-button"
              (click)="deleteTrackingRecord(workflowTracking)" />
          </td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No Trackings found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
